import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class LicenseMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: LicenseMetaModule,
            providers: [
                providePageMeta({
                    title: 'License',
                    translationKey: 'page_license',
                    routerLink: '/license',
                    svgIcon: 'uipath:license',
                    type: 'Admin',
                    permission: 'License.View',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 1,
                }),
                providePageMeta({
                    title: 'License Attended',
                    translationKey: 'RobotType_Attended',
                    routerLink: '/license/attended',
                    svgIcon: 'uipath:license',
                    type: 'Breadcrumb',
                    permission: 'License.View',
                    category: PageCategory.Tenant,
                    parentRoute: '/license',
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'License Unattended',
                    translationKey: 'RobotType_Unattended',
                    routerLink: '/license/unattended',
                    svgIcon: 'uipath:license',
                    type: 'Breadcrumb',
                    permission: 'License.View',
                    category: PageCategory.Tenant,
                    parentRoute: '/license',
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'License Development',
                    translationKey: 'RobotType_Development',
                    routerLink: '/license/development',
                    svgIcon: 'uipath:license',
                    type: 'Breadcrumb',
                    permission: 'License.View',
                    category: PageCategory.Tenant,
                    parentRoute: '/license',
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'License StudioX',
                    translationKey: 'RobotType_StudioX',
                    routerLink: '/license/studiox',
                    svgIcon: 'uipath:license',
                    type: 'Breadcrumb',
                    permission: 'License.View',
                    category: PageCategory.Tenant,
                    parentRoute: '/license',
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'License NonProduction',
                    translationKey: 'RobotType_NonProduction',
                    routerLink: '/license/nonproduction',
                    svgIcon: 'uipath:license',
                    type: 'Breadcrumb',
                    permission: 'License.View',
                    category: PageCategory.Tenant,
                    parentRoute: '/license',
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
